import OverViewWidget from "../Common/OverViewWidget";

const MonitoredBusiness = ({ data, selectedPortfolioId, onClick }) => {
  return (
    <OverViewWidget
      title="Monitored Businesses"
      color="#0099FF"
      downloadURL={data.url}
      epPortfoliosId={selectedPortfolioId}
      data={data.data.details}
      barChart={true}
      menuSelect={onClick}
      spinner={data.loading}
      tileName="monitoredBusiness"
    />
  );
};

export default MonitoredBusiness;
